<script setup lang="ts">
  import { testIds } from '@gat-ship/types'
  import {
    type StakeholderContact,
    type StakeholderType
  } from '@gat-ship/types'
  import { IconEye } from '@gat-ship/icons'
  import { useContactProvider } from '../../../../composables/useStakeholderContacts'
  import { DropdownMenuItem } from '@gat-ship/vue-components'

  const props = withDefaults(
    defineProps<{
      stakeholderId: string
      stakeholderName: string
      stakeholderShortName: string
      stakeholderType: StakeholderType
      contact: StakeholderContact
      label?: string
    }>(),
    {
      label: 'Show Contact Details'
    }
  )

  const { modals } = useContactProvider()
</script>

<template>
  <DropdownMenuItem
    :data-testid="testIds.stakeholders.contacts.actions.showContactDetails"
    @click="
      modals.showViewContactModal({
        stakeholderId: props.stakeholderId,
        stakeholderName: props.stakeholderName,
        stakeholderShortName: props.stakeholderShortName,
        stakeholderType: props.stakeholderType,
        contactType: props.contact.contactType,
        contact: props.contact
      })
    "
  >
    <IconEye class="size-4" />
    {{ label }}
  </DropdownMenuItem>
</template>
